import axios from "axios"
import environment from "../utils/environment"

export const updateCustomerGroup = async (magento_token: string, qservices_token: string)=>{
  const url = `${environment.AZURE_CUSTOMERGROUP_FUNCTION}`
  return await axios.post(url, {magento_token, qservices_token}, {headers: {authorization: `Bearer bce0f00e-acfd-4ea8-9c0c-001a21e0b3a4`}})
}